import React from 'react'
import Lazyload from 'react-lazy-load'
import { Link, graphql } from 'gatsby'
import _ from 'lodash'

import Layout from '../components/layout'
import Grid from '../components/common/grid'
import FAQItem from '../components/common/faq'
import { html_decode } from '../utils'

const Security = props => {
  const wp = props.data.wordpressPage.acf

  const security_intro_image = ['', '/uploads/2018/02/security-intros-1.gif']
  const security_symbol = [
    '/img/sprites/symbols.svg#view',
    '/img/sprites/symbols.svg#lock',
    '/img/sprites/symbols.svg#guard',
    '/img/sprites/symbols.svg#favorite',
  ]
  const security_image = [
    '/uploads/2018/02/security-case-1.svg',
    '/uploads/2018/02/security-case-2.svg',
    '/uploads/2018/02/security-case-3.svg',
    '/uploads/2018/02/security-case-4.svg',
  ]

  wp.security_items = _.map(wp.security_items, (val, idx) => {
    val.image = security_intro_image[idx]
    return val
  })
  wp.security_detail = _.map(wp.security_detail, (val, idx) => {
    val.symbol = security_symbol[idx]
    val.image = security_image[idx]
    return val
  })

  return (
    <Layout
      nav_class={'header--brand-theme'}
      nav_logo={'/img/logo-white.svg'}
      bg={'#47217f'}
    >
      <section className="security-banner">
        <div className="security-banner__inner">
          <div className="security-banner__title">{wp.main_heading}</div>
          <div className="security-banner__subtitle">{wp.sub_heading}</div>
          <div className="security-banner__img-wrapper">
            <img src="/uploads/2018/02/security_2.gif" alt="" />
          </div>
          <div
            className="security-banner__intro"
            dangerouslySetInnerHTML={{ __html: wp.security_intro }}
          />
          <div className="security-banner__footer">
            <img src="/uploads/2018/02/security_1a.svg" alt="" />
          </div>
        </div>
      </section>
      <section className="security-intros">
        <Grid
          items={wp.security_items}
          template={props => (
            <div className="security-intros__item">
              <div className="security-intros__item-img">
                <Lazyload>
                  <img src={props.image} alt="" />
                </Lazyload>
              </div>
              <div className="security-intros__item-title">
                {html_decode(props.security_heading)}
              </div>
              <div
                className="security-intros__item-description"
                dangerouslySetInnerHTML={{ __html: props.security_detail }}
              />
              <div className="security-intros__item-footer">
                {props.button_text ? (
                  <Link
                    to="/how-it-works"
                    dangerouslySetInnerHTML={{ __html: props.button_text }}
                  />
                ) : null}
              </div>
            </div>
          )}
        />
      </section>
      <section className="security-cases">
        <div className="security-cases__inner">
          <Grid
            items={wp.security_detail}
            template={props => (
              <div className="security-cases__item">
                <div className="security-cases__right-part">
                  <div className="security-cases__right-part-decor">
                    <svg>
                      <use href={props.symbol} />
                    </svg>
                  </div>
                  <Lazyload>
                    <img src={props.image} alt="" />
                  </Lazyload>
                </div>
                <div className="security-cases__left-part">
                  <div className="security-cases__title">
                    <div className="security-cases__counter">{props.idx}</div>
                    {props.heading}
                  </div>
                  <div
                    className="security-cases__description"
                    dangerouslySetInnerHTML={{ __html: props.detail }}
                  />
                </div>
              </div>
            )}
          />
        </div>
      </section>
      <section className="qa-section">
        <div className="qa-section__inner">
          <div className="qa-section__title">{wp.security_faq_heading}</div>
          <Grid
            items={wp.security_faq}
            template={props => (
              <FAQItem question={props.question} answer={props.answer} />
            )}
          />
        </div>
      </section>
    </Layout>
  )
}

export const query = graphql`
  query SecurityPage(
    $title: wordpressPageTitleQueryString_2 = { eq: "Security" }
  ) {
    wordpressPage(title: $title) {
      acf {
        main_heading
        sub_heading
        security_intro
        security_items {
          security_heading
          security_detail
          button_text
        }
        security_detail {
          heading
          detail
        }
        security_faq_heading
        security_faq {
          question
          answer
        }
      }
    }
  }
`
export default Security
